import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";

export const CONFIG_ID = "BenchmarkTracker";
export const SECONDARY_BAR_TYPE = "BenchmarkTracker" as SecondaryBarType;
